import React, { useEffect, useRef } from 'react';
import { View } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { V1_SHOW_CHECKOUT, V1_UPDATE_CATALOG_VISIBLE, V1_UPDATE_ITEM_ORDER, V1_UPDATE_WALLET_VISIBILE } from '../store/actionsv1/types';

type CatalogWidgetProps = {
    item_id?:string,
    catalog_id?:string,
    visible:boolean,
    width:number,
    height?:number
}
const MAX_WIDTH = 450;
const CatalogWidget = ({ item_id, catalog_id, width, height, visible } : CatalogWidgetProps) => {

    const dispatch = useDispatch();
    const access_token = useSelector((state:any) => state.auth.access_token, (left, right) => left == right);
    //const catalog_visible = useSelector((state:any) => state.util.catalog_visible, (left, right) => left == right);

    let view_width = width ?? 375
    view_width = view_width > MAX_WIDTH ? MAX_WIDTH : view_width


    useEffect(() => {
        initiateWalletScript()
    },[])

    useEffect(() => {
        if(visible){
            window.addEventListener('message', catalogListener)
        } else {
            window.removeEventListener('message', catalogListener)
        }
    },[visible])

    const catalogListener = (event:any) => {
        if(event.data.widget != 'catalog'){ return }
        switch(event.data.action){
            case 'buy_now':
                console.log(event.data.item_order)
                dispatch({ type: V1_UPDATE_CATALOG_VISIBLE, visible:false })
                dispatch({ type: V1_SHOW_CHECKOUT, show_checkout: { visible:true, draft_order: event.data.item_order } })
                //dispatch({ type: V1_UPDATE_WALLET_VISIBILE, visible: true })
                return
            case 'view_full':
                return
            default:
                return
        }
    }

    const initiateWalletScript = () => { 
        console.log('initiating script!!!')
        const scriptRunTime = document.createElement('script');
        const scriptMain = document.createElement('script');

        scriptRunTime.src = 'https://widgets.bettoredge.com/widget.common.js'
        scriptMain.src = 'https://widgets.bettoredge.com/widget.catalog.js'
        const container = document.getElementById('catalog');
        (container as HTMLElement).appendChild(scriptRunTime);
        (container as HTMLElement).appendChild(scriptMain);
    }
    //return (<></>)
    //if(!wallet_visible){ return <></> }
    return (
        <View>
            <div
                id='catalog'
                style={{ height, overflow:'scroll', width: view_width }}
                data-itemid={item_id}
                data-visible={visible}
                data-catalogid={catalog_id}
            />
        </View>
    )

}

export default CatalogWidget